import { useState, useEffect } from "react";
import { HandySvg } from 'handy-svg';
import iconShareArrow from '../../assets/icons/svg-sprite/share-arrow.svg';
import iconVKFull from '../../assets/icons/svg-sprite/vkontakte-full.svg';
import iconFacebookFull from '../../assets/icons/svg-sprite/facebook-full.svg';
import iconOKFull from '../../assets/icons/svg-sprite/odnoklassniki-full.svg';
import iconAltCross from '../../assets/icons/svg-sprite/close-cross--alt.svg';
import { tv } from "../../lib/api/api";

const Program = ({programm_id, scheme}) => {
    const [info, setInfo] = useState({});
    const [image, setImage] = useState('');

    useEffect(() => {
        tv.program(programm_id)
            .then((res) => {
                setInfo(res);
                if (res.media.large) {
                    res.media.large.forEach(item => {
                        if (item.weight > 0 && item.ratio === "16:9") {
                            setImage(item.url);
                        }
                    });
                } else if (res.media.medium) {
                    res.media.medium.forEach(item => {
                        if (item.weight > 0 && item.ratio === "16:9") {
                            setImage(item.url);
                        }
                    });
                } else if (res.media.small) {
                    res.media.small.forEach(item => {
                        if (item.weight > 0 && item.ratio === "16:9") {
                            setImage(item.url);
                        }
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    function changeOfDate(date) {
        let newDate = '';
        const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
        const index = Number(date.slice(5, 7));
        newDate += `${date.slice(8, 10)} ${months[index - 1]} в ${date.slice(11, 16)}`;
        return newDate;
    }

    return (
        <>
            <div className="tv-program__program-tooltip">
                {Object.keys(info).length === 0 ? (
                    <div className="tv-program-popover">
                        <div className='tv-program-popover__preloader'></div>
                    </div>
                ) : (
                    <div className="tv-program-popover">
                        {image ? (
                            <div className="tv-program-popover__image">
                                <img src={image} width="314" height="220"/>
                            </div>
                        ) : ''}
                        <div className="tv-program-popover__info">
                            <h4 className="tv-program-popover__title">{info.name}</h4>
                            <div className="tv-program-popover__description"><p>{info.title}</p></div>
                            <div className="tv-program-popover__footer js-toggle-socials-in-tv-popover-wrap">
                                <div className="tv-program-popover__date">
                                    <time className="date-label" datetime={scheme.start_at}>{changeOfDate(scheme.start_at)}</time>
                                </div>
                                <div className="tv-program-popover__actions">
                                    <button className="tv-program-popover__action bttn js-show-socials-in-tv-popover-btn" type="button">Поделиться
                                        <HandySvg className="svg-icon tv-program-popover__action-icon" src={iconShareArrow} width="18" height="12"/>
                                    </button>
                                </div>
                                <div className="tv-program-popover__socials share js-share-wrap" data-shareurl={`https://www.telekarta.tv/tvprogram/program/${programm_id}`}>
                                    <span className="visuallyhidden">Кнопки шаринга в социальных сетях</span>
                                    <ul className="share__list">
                                        <li className="share__item">
                                            <button className="share__btn js-share-btn" type="button" data-type="vkontakte">
                                                <span className="visuallyhidden">Поделиться Вконтакте</span>
                                                <HandySvg className="svg-icon" src={iconVKFull} width="40" height="40"/>
                                            </button>
                                        </li>
                                        <li className="share__item">
                                            <button className="share__btn js-share-btn" type="button" data-type="facebook">
                                                <span className="visuallyhidden">Поделиться на Фейсбуке</span>
                                                <HandySvg className="svg-icon" src={iconFacebookFull} width="40" height="40"/>
                                            </button>
                                        </li>
                                        <li className="share__item">
                                            <button className="share__btn js-share-btn" type="button" data-type="odnoklassniki">
                                                <span className="visuallyhidden">Поделиться в Одноклассниках</span>
                                                <HandySvg className="svg-icon" src={iconOKFull} width="40" height="40"/>
                                            </button>
                                        </li>
                                        <li className="share__item">
                                            <button className="share__close-btn js-close-socials-in-tv-popover-btn" type="button">
                                                <span className="visuallyhidden">Закрыть блок шаринга</span>
                                                <HandySvg className="svg-icon" src={iconAltCross} width="24" height="24"/>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Program;
